// Angular
import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
// Environments
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class AppComponent {

  constructor(private meta: Meta) {
    if (!environment.production && !this.meta.getTag('name="robots"')) {
      this.meta.addTag({
        name: 'robots',
        content: 'noindex'
      });
    }
  }
}
